 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];

 		var prefetchChunks = data[3] || [];
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);
 		// chunk prefetching for javascript
 		prefetchChunks.forEach(function(chunkId) {
 			if(installedChunks[chunkId] === undefined) {
 				installedChunks[chunkId] = null;
 				var link = document.createElement('link');

 				if (__webpack_require__.nc) {
 					link.setAttribute("nonce", __webpack_require__.nc);
 				}
 				link.rel = "prefetch";
 				link.as = "script";
 				link.href = jsonpScriptSrc(chunkId);
 				document.head.appendChild(link);
 			}
 		});
 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		14: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		14: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + {"0":"08afb03","1":"05a2026","2":"f80a327","3":"c8c9ad4","4":"b0469e6","5":"748a95f","6":"8c44c89","7":"5c317a8","8":"1826c51","9":"ea44726","10":"d0db44f","11":"860bcd5","12":"b73acae","13":"1e12f37","15":"5a3bdd7","16":"e2fdccf","17":"9cfd157","18":"cc939f2","19":"bdd102d","20":"960cfd9","21":"c20175f","22":"9b83930","23":"41cc862","24":"b17c2ba","25":"0ee82e1","26":"905f0bb","27":"aa96470","28":"5b41ae1","29":"7471fa0","30":"a6b39e6","31":"df5b487","32":"42e73f7","33":"bdb1bb5","34":"3a92f9a","35":"f9a3423","36":"36d7aaa","37":"f29096d","38":"9504f32","39":"bfc7d15","40":"1a3d458","41":"20434d8","42":"0c4e301","43":"1d1f169","44":"ffc832c","45":"da762ce","46":"8e25857","47":"6c7fdb6","48":"72e31cd","49":"e1ed588","50":"fdebf5f","51":"1578f5d","52":"69aa3d7","53":"535812d","54":"d20cf72","55":"f998359","56":"66a3778","57":"5a855bf","58":"44a6667","59":"2e7082f","60":"86e2ad5","61":"9ec37e4","62":"deed079","63":"e22e619","64":"e7901c9","65":"d9733ce","66":"54d3cc7","67":"344dfa1","68":"3771c09","69":"bb6c9db","70":"f93f078","71":"ab84512","72":"76b6701","73":"63880cd","74":"a793d16","75":"0c48181","76":"2cb0a49","77":"46751ee","78":"9a4dabc","79":"e66dfdf","80":"075c6f7","81":"ca94b55","82":"a7a3a96","83":"db0d3c5","84":"a2bf0d6","85":"c387177","86":"65232c9","87":"1ad9075","88":"a78523e","89":"f5f953a","90":"2684192","91":"f2d22cd","92":"ba6dbad","93":"f9b4573","94":"ee969ff","95":"050d429","96":"cf9bda8","97":"ddde36f","98":"6ace5b9","99":"cdf89f0","100":"da1484b","101":"2cd976b","102":"bc6c74e","103":"379da40","104":"c43d613","105":"f00fd70","106":"bf345ba","107":"a1a17fc","108":"39a8582","109":"d16f32a","110":"6193f9f","111":"7c1ba04","112":"2910c37","113":"fd332a2","114":"04bf105","115":"1e54c2b","116":"cb73b95","117":"0c4018e","118":"1edd986","119":"f4b988e","120":"d7ff8ce","121":"1487539","122":"cc5fc1e","123":"ca6345b","124":"a526f2e","125":"92f5e0e","126":"c023f72","127":"f54a5a2","128":"d856344","129":"a75c902","130":"f84923b","131":"9f2bf93","132":"5cafd1c","133":"8c8efca","134":"42ba7d0","135":"751bff8","136":"24541f5","137":"2a36a15","138":"5f1dea5","139":"290ce69","140":"3126156","141":"505d2fa","142":"0e79ca9","143":"31a3964","144":"173607d","145":"3976e1b","146":"16fa111","147":"27cbbac","148":"bff41e1","149":"9c1cb5b","150":"42b84d1","151":"5a7472c","152":"1347913","153":"d722ddc","154":"ef3ee8d","155":"b630c04","156":"d6b69b3","157":"09fef7e","158":"0cce2c5","159":"8859175","160":"92e72a4","161":"215eec9","162":"0a2ab20"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// extract-css-chunks-webpack-plugin CSS loading
 		var supportsPreload = (function() { try { return document.createElement("link").relList.supports("preload"); } catch(e) { return false; }}());
 		var cssChunks = {"34":1,"40":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + {"0":"31d6cfe","1":"31d6cfe","2":"31d6cfe","3":"31d6cfe","4":"31d6cfe","5":"31d6cfe","6":"31d6cfe","7":"31d6cfe","8":"31d6cfe","9":"31d6cfe","10":"31d6cfe","11":"31d6cfe","12":"31d6cfe","13":"31d6cfe","15":"31d6cfe","16":"31d6cfe","17":"31d6cfe","18":"31d6cfe","19":"31d6cfe","20":"31d6cfe","21":"31d6cfe","22":"31d6cfe","23":"31d6cfe","24":"31d6cfe","25":"31d6cfe","26":"31d6cfe","27":"31d6cfe","28":"31d6cfe","29":"31d6cfe","30":"31d6cfe","31":"31d6cfe","32":"31d6cfe","33":"31d6cfe","34":"ce80352","35":"31d6cfe","36":"31d6cfe","37":"31d6cfe","38":"31d6cfe","39":"31d6cfe","40":"6d7b09a","41":"31d6cfe","42":"31d6cfe","43":"31d6cfe","44":"31d6cfe","45":"31d6cfe","46":"31d6cfe","47":"31d6cfe","48":"31d6cfe","49":"31d6cfe","50":"31d6cfe","51":"31d6cfe","52":"31d6cfe","53":"31d6cfe","54":"31d6cfe","55":"31d6cfe","56":"31d6cfe","57":"31d6cfe","58":"31d6cfe","59":"31d6cfe","60":"31d6cfe","61":"31d6cfe","62":"31d6cfe","63":"31d6cfe","64":"31d6cfe","65":"31d6cfe","66":"31d6cfe","67":"31d6cfe","68":"31d6cfe","69":"31d6cfe","70":"31d6cfe","71":"31d6cfe","72":"31d6cfe","73":"31d6cfe","74":"31d6cfe","75":"31d6cfe","76":"31d6cfe","77":"31d6cfe","78":"31d6cfe","79":"31d6cfe","80":"31d6cfe","81":"31d6cfe","82":"31d6cfe","83":"31d6cfe","84":"31d6cfe","85":"31d6cfe","86":"31d6cfe","87":"31d6cfe","88":"31d6cfe","89":"31d6cfe","90":"31d6cfe","91":"31d6cfe","92":"31d6cfe","93":"31d6cfe","94":"31d6cfe","95":"31d6cfe","96":"31d6cfe","97":"31d6cfe","98":"31d6cfe","99":"31d6cfe","100":"31d6cfe","101":"31d6cfe","102":"31d6cfe","103":"31d6cfe","104":"31d6cfe","105":"31d6cfe","106":"31d6cfe","107":"31d6cfe","108":"31d6cfe","109":"31d6cfe","110":"31d6cfe","111":"31d6cfe","112":"31d6cfe","113":"31d6cfe","114":"31d6cfe","115":"31d6cfe","116":"31d6cfe","117":"31d6cfe","118":"31d6cfe","119":"31d6cfe","120":"31d6cfe","121":"31d6cfe","122":"31d6cfe","123":"31d6cfe","124":"31d6cfe","125":"31d6cfe","126":"31d6cfe","127":"31d6cfe","128":"31d6cfe","129":"31d6cfe","130":"31d6cfe","131":"31d6cfe","132":"31d6cfe","133":"31d6cfe","134":"31d6cfe","135":"31d6cfe","136":"31d6cfe","137":"31d6cfe","138":"31d6cfe","139":"31d6cfe","140":"31d6cfe","141":"31d6cfe","142":"31d6cfe","143":"31d6cfe","144":"31d6cfe","145":"31d6cfe","146":"31d6cfe","147":"31d6cfe","148":"31d6cfe","149":"31d6cfe","150":"31d6cfe","151":"31d6cfe","152":"31d6cfe","153":"31d6cfe","154":"31d6cfe","155":"31d6cfe","156":"31d6cfe","157":"31d6cfe","158":"31d6cfe","159":"31d6cfe","160":"31d6cfe","161":"31d6cfe","162":"31d6cfe"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if((tag.rel === "stylesheet" || tag.rel === "preload") && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = supportsPreload ? "preload": "stylesheet";
 				supportsPreload ? linkTag.as = "style" : linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0]; head.appendChild(linkTag)
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 				if(supportsPreload) {
 					var execLinkTag = document.createElement("link");
 					execLinkTag.href =  __webpack_require__.p + "css/" + {"0":"31d6cfe","1":"31d6cfe","2":"31d6cfe","3":"31d6cfe","4":"31d6cfe","5":"31d6cfe","6":"31d6cfe","7":"31d6cfe","8":"31d6cfe","9":"31d6cfe","10":"31d6cfe","11":"31d6cfe","12":"31d6cfe","13":"31d6cfe","15":"31d6cfe","16":"31d6cfe","17":"31d6cfe","18":"31d6cfe","19":"31d6cfe","20":"31d6cfe","21":"31d6cfe","22":"31d6cfe","23":"31d6cfe","24":"31d6cfe","25":"31d6cfe","26":"31d6cfe","27":"31d6cfe","28":"31d6cfe","29":"31d6cfe","30":"31d6cfe","31":"31d6cfe","32":"31d6cfe","33":"31d6cfe","34":"ce80352","35":"31d6cfe","36":"31d6cfe","37":"31d6cfe","38":"31d6cfe","39":"31d6cfe","40":"6d7b09a","41":"31d6cfe","42":"31d6cfe","43":"31d6cfe","44":"31d6cfe","45":"31d6cfe","46":"31d6cfe","47":"31d6cfe","48":"31d6cfe","49":"31d6cfe","50":"31d6cfe","51":"31d6cfe","52":"31d6cfe","53":"31d6cfe","54":"31d6cfe","55":"31d6cfe","56":"31d6cfe","57":"31d6cfe","58":"31d6cfe","59":"31d6cfe","60":"31d6cfe","61":"31d6cfe","62":"31d6cfe","63":"31d6cfe","64":"31d6cfe","65":"31d6cfe","66":"31d6cfe","67":"31d6cfe","68":"31d6cfe","69":"31d6cfe","70":"31d6cfe","71":"31d6cfe","72":"31d6cfe","73":"31d6cfe","74":"31d6cfe","75":"31d6cfe","76":"31d6cfe","77":"31d6cfe","78":"31d6cfe","79":"31d6cfe","80":"31d6cfe","81":"31d6cfe","82":"31d6cfe","83":"31d6cfe","84":"31d6cfe","85":"31d6cfe","86":"31d6cfe","87":"31d6cfe","88":"31d6cfe","89":"31d6cfe","90":"31d6cfe","91":"31d6cfe","92":"31d6cfe","93":"31d6cfe","94":"31d6cfe","95":"31d6cfe","96":"31d6cfe","97":"31d6cfe","98":"31d6cfe","99":"31d6cfe","100":"31d6cfe","101":"31d6cfe","102":"31d6cfe","103":"31d6cfe","104":"31d6cfe","105":"31d6cfe","106":"31d6cfe","107":"31d6cfe","108":"31d6cfe","109":"31d6cfe","110":"31d6cfe","111":"31d6cfe","112":"31d6cfe","113":"31d6cfe","114":"31d6cfe","115":"31d6cfe","116":"31d6cfe","117":"31d6cfe","118":"31d6cfe","119":"31d6cfe","120":"31d6cfe","121":"31d6cfe","122":"31d6cfe","123":"31d6cfe","124":"31d6cfe","125":"31d6cfe","126":"31d6cfe","127":"31d6cfe","128":"31d6cfe","129":"31d6cfe","130":"31d6cfe","131":"31d6cfe","132":"31d6cfe","133":"31d6cfe","134":"31d6cfe","135":"31d6cfe","136":"31d6cfe","137":"31d6cfe","138":"31d6cfe","139":"31d6cfe","140":"31d6cfe","141":"31d6cfe","142":"31d6cfe","143":"31d6cfe","144":"31d6cfe","145":"31d6cfe","146":"31d6cfe","147":"31d6cfe","148":"31d6cfe","149":"31d6cfe","150":"31d6cfe","151":"31d6cfe","152":"31d6cfe","153":"31d6cfe","154":"31d6cfe","155":"31d6cfe","156":"31d6cfe","157":"31d6cfe","158":"31d6cfe","159":"31d6cfe","160":"31d6cfe","161":"31d6cfe","162":"31d6cfe"}[chunkId] + ".css";
 					execLinkTag.rel = "stylesheet";
 					execLinkTag.type = "text/css";
 					document.body.appendChild(execLinkTag);
 				}
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://cdn-static.ecosia.org/web/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 232);
